import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './index.css'
import './styles/ui.css'
import App from './App.jsx'
import { attachServiceWorkerSoundListener, unlockAudioOnFirstInteraction } from './lib/notificationSound'
import { applyInitialTheme } from './hooks/useTheme'

applyInitialTheme()
attachServiceWorkerSoundListener()
unlockAudioOnFirstInteraction()

// Captura el codigo de referido del query string (?ref=UUID) al cargar la
// app. Lo guardamos en localStorage para que cuando el visitante se registre
// (incluso varios dias despues), Register.jsx lo lea y lo pase a
// users.referred_by. Sin esto, los links de referidos nunca funcionaban —
// el codigo se perdia en cuanto el visitante navegaba a /registro.
try {
  const params = new URLSearchParams(window.location.search)
  const ref = params.get('ref')
  // Validacion basica de UUID v4 (8-4-4-4-12 hex)
  if (ref && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(ref)) {
    localStorage.setItem('bellason_ref', ref)
  }
} catch { /* localStorage bloqueado o param ausente */ }

// Registra el Service Worker al cargar la app (no solo cuando se acepta push).
// Así todos los usuarios tienen PWA instalable y caching, incluso si rechazan
// notificaciones.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(reg => {
        // Force SW update check on every page load so new versions activate immediately
        reg.update()
      })
      .catch(err => {
        console.warn('SW register falló:', err)
      })
  })
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)